import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _SAVE_USER_ROLE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.RBAC.USER_ROLES.SAVE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_USER_ROLES = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.RBAC.USER_ROLES.LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _DELETE_USER_ROLE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.RBAC.USER_ROLES.DELETE;
  return callApi(url, "post", searchData && searchData);
};

export const _USER_ROLE_STATUS_UPDATE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.RBAC.USER_ROLES.STATUS_UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_USER_ROLE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.RBAC.USER_ROLES.UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_ROLE_AND_ACCESS_PERMISSIONS = async (
  searchData = false
) => {
  let url = ServiceUrl.SETTINGS.RBAC.ROLE_AND_ACCESS.UPDATE_ROLE_AND_ACCESS;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_ROLE_AND_PERMISSIONS = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.RBAC.ROLE_AND_ACCESS.LIST_ROLE_AND_PERMISSIONS;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};
